import service from "@/api/service";
import { GetResponse } from "@/api/image-shop-preview/response";
import { GetRequest } from "@/api/image-shop-preview/request";

/**
 * 公開画像プレビューAPIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/preview-image-shop", getRequest);
  return response.data as GetResponse;
}
